<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础信息" name="gjcxx">
            <div>
              <el-form :model="detailInfo" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
                <el-form-item label="商品名称：" prop="apiGoodsName">
                  <el-input style="width: 424px;" v-model="detailInfo.apiGoodsName"></el-input>
                </el-form-item>
                <el-form-item label="商品副标题：" prop="subTitle">
                  <el-input style="width: 424px;" placeholder="请输入商品副标题" v-model="detailInfo.subTitle"></el-input>
                </el-form-item>
                <el-form-item label="商品单位：" prop="apiUnitName">
                  <el-input style="width: 424px;" v-model="detailInfo.apiUnitName" disabled></el-input>
                </el-form-item>
                <el-form-item label="商品分类 ：" prop="categoryTreePageVoList">
                  <el-cascader
                    v-model="cateIds"
                    style="width: 424px;"
                    :options="cateOptions"
                    :props="props"
                    collapse-tags
                    clearable></el-cascader>
                </el-form-item>
                <el-form-item label="商品主图：" prop="thumb">
                  <el-upload
                    :action="baseUrl+'/system/common/upload/uploadFile'"
                    list-type="picture-card"
                    :headers="{'Authorization': token}"
                    :multiple="false"
                    :limit="1"
                    :file-list="fileList"
                    :on-remove="delImgBtn.bind(null,{'type':1})"
                    :on-success="uploadImgBtn">
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多一张，若需要更换图片，请先删除原图片</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="商品相册：" prop="goodsPicturePageVoList">
                  <el-upload
                    :action="baseUrl+'/system/common/upload/uploadFile'"
                    list-type="picture-card"
                    :headers="{'Authorization': token}"
                    :multiple="true"
                    :limit="5"
                    :file-list="goodsPicturePageVoListTwo"
                    :on-remove="delImgBtn.bind(null,{'type':2})"
                    :on-success="uploadTwoBtn">
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多9张，若需要更换图片，请先删除原图片</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="商品视频：" prop="goodsVideoUrl">
                  <el-input style="width: 424px;" v-model="detailInfo.goodsVideoUrl" placeholder="请输入商品视频"></el-input>
                  <el-upload
                    :action="baseUrl+'/system/common/upload/uploadFile'"
                    :multiple="false"
                    :headers="{'Authorization': token}"
                    :limit="1"
                    :on-success="uploadVideoBtn">
                    <div class="color-theme">上传视频</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="视频封面：" prop="goodsVideoCover">
                  <el-upload
                    :action="baseUrl+'/system/common/upload/uploadFile'"
                    list-type="picture-card"
                    :headers="{'Authorization': token}"
                    :multiple="false"
                    :limit="1"
                    :file-list="goodsVideoCoverArr"
                    :on-remove="delImgBtn.bind(null,{'type':4})"
                    :on-success="uploadImgPosterBtn">
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多一张，若需要更换图片，请先删除原图片</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="商品标签：" prop="goodsLabelPageVoList">
                  <el-select
                    style="width: 424px;"
                    v-model="labelValue"
                    multiple
                    collapse-tags
                    placeholder="请选择">
                    <el-option
                      v-for="item in labelList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="服务说明：" prop="serviceDescIdList">
                  <el-select
                    style="width: 424px;"
                    v-model="serviceDescIdValue"
                    multiple
                    collapse-tags
                    placeholder="请选择">
                    <el-option
                      v-for="item in serviceDescIdList"
                      :key="item.serviceDescId"
                      :label="item.serviceName"
                      :value="item.serviceDescId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="配送说明：" prop="deliveryTimeDesc">
                  <el-input style="width: 424px;" placeholder="请输入配送说明" v-model="detailInfo.deliveryTimeDesc"></el-input>
                </el-form-item>
                <el-form-item label="是否开启：" prop="status">
                  <el-switch
                    v-model="detailInfo.status"
                    active-color="#1890FF"
                    inactive-color="#CCCCCC">
                  </el-switch>
                </el-form-item>
                <el-form-item label="是否首页显示：" prop="isShowHome">
                  <el-switch
                    v-model="detailInfo.isShowHome"
                    active-color="#1890FF"
                    inactive-color="#CCCCCC">
                  </el-switch>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="medium" @click="nextBtn('gggkc')">下一步</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="规格库存" name="gggkc">
            <el-table
              :data="detailInfo.goodsSpecPageVoList"
              border
              style="width: 100%">
              <el-table-column
                prop="apiSpecName"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="thumb"
                label="图片"
                width="180">
                <template slot-scope="scope">
                  <!-- <div class="flex-row">
                    <el-image
                      v-if="scope.row.thumb != null"
                      style="width:32px;height:32px;margin-right: 8px;"
                      :src="scope.row.thumb"
                      fit="contain"></el-image>
                    <el-upload
                      class="upload-demo"
                      :action="baseUrl+'/system/common/upload/uploadFile'"
                      :headers="{'Authorization': token}"
                      :multiple="false"
                      :limit="1"
                      :show-file-list="false"
                      :on-exceed="uploadExceedBtn.bind(null,{'index':scope.$index})"
                      :on-remove="delImgBtn.bind(null,{'type':3,'index':scope.$index})"
                      :on-success="uploadImgSpBtn.bind(null,{'index':scope.$index})">
                        <el-image
                          style="width:32px;height:32px;"
                          :src="imgServer+'uploadBtn.png'"
                          fit="contain"></el-image>
                      <div slot="tip" class="el-upload__tip">最多一张</div>
                    </el-upload>
                  </div> -->
                  <el-upload
                    :action="baseUrl+'/system/common/upload/uploadFile'"
                    list-type="picture-card"
                    :headers="{'Authorization': token}"
                    :multiple="false"
                    :limit="1"
                    :file-list="scope.row.thumbArr"
                    :on-remove="delImgBtn.bind(null,{'type':3,'index':scope.$index})"
                    :on-success="uploadImgSpBtn.bind(null,{'index':scope.$index})">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">最多一张，若需要更换图片，请先删除原图片</div>
                  </el-upload>
                </template>
              </el-table-column>
              <el-table-column
                prop="apiSpecPrice"
                label="售价">
              </el-table-column>
              <el-table-column
                prop="apiMarketPrice"
                label="划线价">
              </el-table-column>
              <el-table-column
                prop="apiStockNum"
                label="库存">
                <template slot-scope="scope">
                  <el-input style="width: 120px;" v-model="scope.row.apiStockNum" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="apiWeight"
                label="重量(kg)">
              </el-table-column>
              <el-table-column
                prop="apiStockVolume"
                label="体积(m³)">
              </el-table-column>
              <el-table-column
                prop="isDefault"
                label="默认选中规格">
                <template slot-scope="scope">
                  <img @click="chooseDefaultBtn(scope.row.id)" class="mt-table-goods-choose" :src="scope.row.isDefault == 1 ? imgServer+'choosed_icon.png' : imgServer+'choose_icon.png'" />
                </template>
              </el-table-column>
            </el-table>
            <div class="flex-row-align" style="margin-top: 24px;">
              <el-button size="medium" @click="preBtn('gjcxx')">上一步</el-button>
              <el-button type="primary" size="medium" @click="nextBtn('gspxq')">下一步</el-button>
              <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="商品详情" name="gspxq">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="40px" size="small" class="demo-ruleForm">
              <el-form-item>
                <editor :value="detailInfo.goodsDetail" :height="690" v-model="detailInfo.goodsDetail"></editor>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" @click="preBtn('gggkc')">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextBtn('gwlsz')">下一步</el-button>
                <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="物流设置" name="gwlsz">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
              <el-form-item label="配送方式：" prop="name">
                <el-checkbox v-model="expressDelivery">快递配送</el-checkbox>
                <el-checkbox v-model="pickupDelivery">自提</el-checkbox>
                <el-checkbox v-model="enableDelivery">同城配送</el-checkbox>
              </el-form-item>
              <el-form-item label="设置邮费 ：" prop="name">
                <el-select style="width: 424px;" v-model="detailInfo.moveTemplateId" placeholder="请选择运费模版">
                  <el-option
                    v-for="item in moveData"
                    :key="item.id"
                    :label="item.templateName"
                    :value="item.id">
                  </el-option>
                </el-select>
                <div class="color-theme" @click="moveDrawer=true" style="cursor: pointer;">运费模版</div>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" @click="preBtn('gspxq')">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextBtn('gyxsz')">下一步</el-button>
                <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="营销设置" name="gyxsz">
            <el-form :model="detailInfo" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
              <el-form-item label="虚拟销量：" prop="virtualSalesNumber">
                <el-input style="width: 424px;" v-model="detailInfo.virtualSalesNumber" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="起售数量：" prop="startSaleNumber">
                <el-input style="width: 424px;" v-model="detailInfo.startSaleNumber" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="排序：" prop="sort">
                <el-input style="width: 424px;" v-model="detailInfo.sort" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="参与分佣：" prop="enableShar">
                <el-radio-group v-model="detailInfo.enableShar">
                  <el-radio :label="1">参与</el-radio>
                  <el-radio :label="0">不参与</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="参与折扣：" prop="enableDiscount">
                <el-radio-group v-model="detailInfo.enableDiscount">
                  <el-radio :label="1">参与</el-radio>
                  <el-radio :label="0">不参与</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="余额支付：" prop="isUseMoney">
                <el-radio-group v-model="detailInfo.isUseMoney">
                  <el-radio :label="1">允许</el-radio>
                  <el-radio :label="0">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" @click="preBtn('gwlsz')">上一步</el-button>
                <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
<!--    添加运费模版弹窗-->
    <el-drawer
      size="960px"
      title="运费模板"
      :visible.sync="moveDrawer">
      <el-form ref="moveForm" :model="moveForm" :rules="rules" label-width="140px">
        <el-form-item label="模版名称：">
          <el-input style="width: 424px;" v-model="moveForm.templateName" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="包邮方式：">
          <el-radio-group v-model="moveForm.shipMethod">
            <el-radio :label="1">包邮</el-radio>
            <el-radio :label="2">部分包邮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="moveForm.shipMethod == 2" label="计费方式：">
          <el-radio-group v-model="moveForm.chargeMethod">
            <el-radio :label="1">按件数</el-radio>
            <el-radio :label="2">按重量</el-radio>
            <el-radio :label="3">按体积</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="moveForm.shipMethod == 2" label="运费：">
          <el-table
            :data="moveForm.goodsMoveTemplateChargeSaveDtoList"
            border
            style="width: 100%">
            <el-table-column
              prop="chargeType"
              label="送达到"
              width="180">
              <template slot-scope="scope">
                <el-select v-model="scope.row.areaIdList" multiple placeholder="请选择">
                  <el-option
                    v-for="item in areaList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="firstArticle"
              :label="moveForm.chargeMethod == 1 ? '首件' : moveForm.chargeMethod ==  2 ? '首重量(KG)' : '首件体积(m³)'"
              width="130">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.firstArticle" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="firstMoveMoney"
              label="运费(元)">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.firstMoveMoney" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="continueArticle"
              :label="moveForm.chargeMethod == 1 ? '续件' : moveForm.chargeMethod ==  2 ? '续重量(KG)' : '续件体积(m³)'"
              width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.continueArticle" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="continueMoveMoney"
              label="续费(元)">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.continueMoveMoney" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="80">
              <template slot-scope="scope">
                <el-button @click="delTableBtn(scope.$index)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" style="margin-top: 24px;" @click="addTableBtn">添加区域</el-button>
        </el-form-item>
        <el-form-item v-if="moveForm.shipMethod == 2" label="包邮区域：">
          <el-select style="width: 424px;" v-model="areaChooseList" multiple placeholder="请选择">
            <el-option
              v-for="item in areaList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序 ：">
          <el-input style="width: 424px;" v-model="moveForm.sort" placeholder="请输入排序，默认1"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="moveOffBtn">取消</el-button>
          <el-button @click="moveSureBtn" type="primary" size="medium">确定</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { goodsDetail, searchCateInfo, queryAllGoodsLabelList, queryAllGoodsMoveTemplateList, queryAreaTreeList, saveGoodsMoveTemplate, updateWebGoods, saveOrUpdateServiceGoodsBind, queryAllEnableServiceDescList } from '@/api/goods'
import Editor from '@/components/Editor.vue'

export default {
  name: 'GoodsEdit',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      activeName: 'gjcxx',
      fullscreenLoading: false,
      /* 商品分类 */
      cateOptions:[],
      props: { multiple: true },
      cateIds:[],
      labelList:[],
      labelValue:[],
      // 服务说明
      serviceDescIdList:[],
      serviceDescIdValue:[],
      pickupDelivery:false,
      expressDelivery:false,
      enableDelivery:false,
      currentIndex:0,
      detailInfo:{
        apiGoodsName: "",
        thumb: "",
        goodsVideoUrl: "",
        subTitle: "",
        apiUnitName: "",
        categoryTreePageVoList: [],
        goodsPicturePageVoList: [],
        goodsLabelPageVoList: [],
        serviceDescIdList:[],
        deliveryTimeDesc: "",
        id: "",
        status: true,
        isShowHome:false,
        sort: "",
        virtualSalesNumber: "",
        pickupDelivery: "",
        expressDelivery: "",
        enableDelivery:"",
        moveTemplateId: "",
        moveTemplateName: "",
        goodsSpecPageVoList: [],
        goodsDetail: "",
        startSaleNumber:'',
        enableShar:0,
        enableDiscount:0,
        isUseMoney:0
      },
      fileList: [],
      goodsVideoCoverArr:[],
      /* 商品相册 */
      goodsPicturePageVoListTwo: [],
      goodsPicturePageVoList:[],
      videoList:[],
      moveData:[],
      moveDrawer: false,
      moveForm:{
        templateName: '',
        shipMethod:1,
        chargeMethod:1,
        sort:'',
        goodsMoveTemplateChargeSaveDtoList:[{
          chargeType:0,
          areaIdList:[],
          firstArticle:'',
          firstMoveMoney:'',
          continueMoveMoney:'',
          continueArticle:''
        }]
      },
      areaList:[],
      areaChooseList:[],
      ruleForm: {
        name: '',
        url: '',
        type: '',
        weburl: '',
        minAppId: '',
        sort: '',
        status: true
      },
      rules: {
        apiGoodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        categoryTreePageVoList: [
          { required: true, message: '请选择分类', trigger: 'blur' }
        ],
        thumb: [
          { required: true, message: '请上传商品主图', trigger: 'blur' }
        ],
        goodsPicturePageVoList: [
          { required: true, message: '请上传商品相册', trigger: 'blur' }
        ],
        templateName: [
          { required: true, message: '请选择模版名称', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    this.detailInfoFun();
    this.cateDataFun();
    this.goodsLabelInfoFun();
    this.serviceListFun();
    // this.serviceInfoFun();
  },
  methods: {
    /* 商品详情数据 */
    detailInfoFun(){
      var that = this;
      goodsDetail({id:that.dataId}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          data.status =  data.status == 1 ? true : false;
          data.isShowHome =  data.isShowHome == 1 ? true : false;
          // 配送
          if(data.expressDelivery == 1){
            that.expressDelivery = true;
          }else{
            that.expressDelivery = false;
          }
          // 自提
          if(data.pickupDelivery == 1){
            that.pickupDelivery = true;
          }else{
            that.pickupDelivery = false;
          }
          // 同城配送
          if(data.enableDelivery == 1){
            that.enableDelivery = true;
          }else{
            that.enableDelivery = false;
          }
          data.goodsSpecPageVoList.forEach((item)=>{
            item.thumbArr = [];
          });
          // 商品分类
          var cateIds = [];
          data.categoryTreePageVoList.forEach(function(item){
            item.children.forEach(function(item2){
              cateIds.push([item.id,item2.id])
            });
          });
          that.cateIds = cateIds;
          // 商品主图
          that.fileList.push({url: data.thumb});
          // 视频封面
          if(data.goodsVideoCover != null && data.goodsVideoCover != ''){
            that.goodsVideoCoverArr.push({url: data.goodsVideoCover});
          }
          // 商品相册
          data.goodsPicturePageVoList.forEach(function(item){
            that.goodsPicturePageVoListTwo.push({url: item.pictureUrl});
            that.goodsPicturePageVoList.push(item.pictureUrl);
          });
          // 商品标签
          data.goodsLabelPageVoList.forEach(function(item){
            that.labelValue.push(item.id);
          });
          // 商品服务说明
          data.serviceDescIdPageVoList.forEach(function(item){
            that.serviceDescIdValue.push(item.serviceDescId);
          });
          // 商品规格图片
          data.goodsSpecPageVoList.forEach(function(item){
            item.thumbArr.push({url: item.thumb});
          });
          that.detailInfo = data;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    // 获取所有已上架服务说明数据
    serviceListFun(){
      var that = this;
      queryAllEnableServiceDescList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          that.serviceDescIdList = data;
        }
      });
    },
    // // 编辑后获取服务说明数据
    // serviceInfoFun(){
    //   var that = this;
    //   queryServiceGoodsListByGoodsId({goodsId:that.dataId}).then((res) => {
    //     if (res.errorCode === '0000') {
    //       let data = res.data;
    //     }
    //   });
    // },
    /* 商品分类数据 */
    cateDataFun(){
      var that = this;
      searchCateInfo().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          that.cateOptions = data;
        }
      });
    },
    /* 商品标签数据 */
    goodsLabelInfoFun(){
      var that = this;
      queryAllGoodsLabelList().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          that.labelList = data;
        }
      });
    },
    // 监听选项卡操作
    handleClick(tab) {
      if(tab.name == 'gwlsz'){
        this.moveDataFun();
      }
    },
    /* 获取运费模版数据和省市区数据 */
    moveDataFun(){
      var that = this;
      queryAllGoodsMoveTemplateList().then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.moveData = data;
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      });
      queryAreaTreeList().then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.areaList = data;
        }
      });
    },
    /* 运费模版table添加一行 */
    addTableBtn(){
      var singleValue = {
        chargeType:0,
        areaIdList:[],
        firstArticle:'',
        firstMoveMoney:'',
        continueMoveMoney:'',
        continueArticle:''
      }
      this.moveForm.goodsMoveTemplateChargeSaveDtoList.push(singleValue);
    },
    /* 运费模版table删除一行 */
    delTableBtn(index){
      this.moveForm.goodsMoveTemplateChargeSaveDtoList.splice(index,1);
    },
    /* 运费模版取消添加操作 */
    moveOffBtn(){
      this.moveDrawer = false;
    },
    /* 运费模版确认添加操作 */
    moveSureBtn(){
      var that = this;
      var moveForm = that.moveForm;
      var areaChooseList = that.areaChooseList;
      var passData = moveForm;
      passData.areaIdList = areaChooseList;
      saveGoodsMoveTemplate(passData).then((res) => {
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.moveDrawer = false;
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    // 返回上一页
    backPage () {
      this.$router.back()
    },
    // 商品主图上传
    uploadImgBtn (file) {
      this.detailInfo.thumb = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 商品主图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.detailInfo.thumb = thumb;
          break;
        case 2:
          // 商品相册
          var goodsPicturePageVoList = [];
          fileList.forEach(function(item){
            goodsPicturePageVoList.push(item.url);
          });
          that.goodsPicturePageVoList = goodsPicturePageVoList;
          break;
        case 3:
          // 商品列表规格图片
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.detailInfo.goodsSpecPageVoList[obj.index].thumb = thumb;
          break;
        case 4:
          // 视频封面上传
          var goodsVideoCover = '';
          fileList.forEach(function(item){
            goodsVideoCover = item.url;
          });
          that.detailInfo.goodsVideoCover = goodsVideoCover;
          break;
      }
    },
    /* 商品相册上传 */
    uploadTwoBtn (file) {
      this.goodsPicturePageVoList.push(file.data.fileUrl)
    },
    /* 规格中的缩略图 */
    uploadImgSpBtn (obj,file) {
      // console.log('Upload success', obj,file);
      this.detailInfo.goodsSpecPageVoList[obj.index].thumb = file.data.fileUrl
    },
    uploadExceedBtn(obj, file, fileList){
      console.log(obj, file, fileList,'file, fileList');
      this.$message.warning('只能上传一张图片');
      // 阻止默认行为，即不删除已上传的图片
      this.detailInfo.goodsSpecPageVoList[obj].thumbArr.pop(); // 如果需要的话，可以从列表中移除最后一个文件，但这通常不必要，除非你想要在用户看到警告后手动选择移除某个文件
      this.detailInfo.goodsSpecPageVoList[obj].thumbArr.push(file[0]);
    },
    /* 视频上传 */
    uploadVideoBtn (file) {
      this.videoList = file.data.fileUrl
    },
    /* 视频封面上传 */
    uploadImgPosterBtn (file) {
      this.detailInfo.goodsVideoCover = file.data.fileUrl
    },
    /* 下一步操作 */
    nextBtn(name){
      this.activeName = name;
    },
    /* 上一步操作 */
    prevBtn(name){
      this.activeName = name;
    },
    /* 选择默认 */
    chooseDefaultBtn(infoId){
      this.detailInfo.goodsSpecPageVoList.forEach((item) => {
        if(infoId == item.id){
          item.isDefault = 1;
        }else{
          item.isDefault = 0;
        }
      });
    },
    // 保存操作
    saveBtn () {
      let that = this
      var detailInfo = that.detailInfo;
      let dataId = that.dataId
      let goodsVideoUrl = detailInfo.goodsVideoUrl;
      let videoList = that.videoList;
      if(videoList != ''){
        goodsVideoUrl = videoList
      }
      let cateIds = that.cateIds;
      let categoryIdList = [];
      cateIds.forEach(item => {
        categoryIdList.push(item[1])
      });
      let status = detailInfo.status ? 1 : 0
      let isShowHome = detailInfo.isShowHome ? 1 : 0
      let sort = detailInfo.sort === '' ? 1 : detailInfo.sort
      if (detailInfo.apiGoodsName === '') {
        this.$message.error('请输入商品名称')
        return false
      }
      if (that.serviceDescIdValue.length <= 0) {
        this.$message.error('请选择服务说明')
        return false
      }
      let passData = {
        id: dataId,
        apiGoodsName:detailInfo.apiGoodsName,
        subTitle:detailInfo.subTitle,
        thumb:detailInfo.thumb,
        goodsVideoCover:detailInfo.goodsVideoCover,
        goodsVideoUrl:goodsVideoUrl,
        goodsDetail:detailInfo.goodsDetail,
        virtualSalesNumber:detailInfo.virtualSalesNumber,
        enableDiscount:detailInfo.enableDiscount,
        moveTemplateId:detailInfo.moveTemplateId,
        enableShar:detailInfo.enableShar,
        deliveryTimeDesc:detailInfo.deliveryTimeDesc,
        status:status,
        isShowHome:isShowHome,
        sort:sort,
        pickupDelivery:that.pickupDelivery == true ? 1 : 0,
        expressDelivery:that.expressDelivery == true ? 1 : 0,
        enableDelivery:that.enableDelivery == true ? 1 : 0,
        categoryIdList:categoryIdList,
        pictureUrlList:that.goodsPicturePageVoList,
        labelIdList:that.labelValue,
        startSaleNumber:detailInfo.startSaleNumber,
        goodsSpecSaveDtoList:detailInfo.goodsSpecPageVoList,
        isUseMoney:detailInfo.isUseMoney
      }
      // console.log(passData,'passData');
      that.fullscreenLoading = true;
      updateWebGoods(passData).then((res) => {
        that.fullscreenLoading = false;
        if (res.errorCode === '0000') {
          that.$router.back()
          that.$message({
            message: res.msg,
            type: 'success',
            onClose () {}
          })
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
      that.serviceSaveBtn();
    },
    // 服务说明保存
    serviceSaveBtn(){
      var that = this;
      if (that.serviceDescIdValue.length <= 0) {
        this.$message.error('请选择服务说明')
        return false
      }
      saveOrUpdateServiceGoodsBind({goodsId:that.dataId,serviceDescIdList:that.serviceDescIdValue}).then((res) => {
        if (res.errorCode === '0000') {}
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/Edit.vue